import { render, staticRenderFns } from "./QuoteDocumentPackageBuilderSideMenu.vue?vue&type=template&id=322f27b6&"
import script from "./QuoteDocumentPackageBuilderSideMenu.vue?vue&type=script&lang=ts&"
export * from "./QuoteDocumentPackageBuilderSideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteDocumentPackageBuilderSideMenu.vue?vue&type=style&index=0&id=322f27b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports